/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RestrictionMixinNotSetPassword } from './RestrictionMixinNotSetPassword';
import { RestrictionMixinSetPassword } from './RestrictionMixinSetPassword';
const RestrictionMixinParser = /* #__PURE__ */ parsers.object([
    [
        'password',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['set', RestrictionMixinSetPassword],
            ['not-set', RestrictionMixinNotSetPassword],
        ]),
    ],
]);
export class RestrictionMixin extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RestrictionMixinParser.decode(input).map(res => new RestrictionMixin(res));
    }
    static unsafeDecode(input) {
        return RestrictionMixin.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RestrictionMixinParser.encode(data);
    }
    static schema() {
        return RestrictionMixinParser.schema();
    }
}
